import { noop } from "lodash";
import * as React from "react";
import { imageAnnotationsResx } from "../../../resxDist/imageAnnotationsResx";
import { icon } from "../../../sharedComponents/icons";
import { Menu, MenuItem } from "../../../sharedComponents/menu";
import { FocusTrap } from "../../../sharedHOC/adjustContainer/FocusTrap";
import { AnnotationItemExtended } from "../types";
import { ActionConfirmation } from "./ActionConfirmation";
import * as styles from "./ImageAnnotationMenu.less";

interface ImageAnnotationMenuState {
    showDeleteConfirmation: boolean;
}

type ImageAnnotationMenuProps = {
    annotation: AnnotationItemExtended;
    startEditAction: F<void>;
    applyDeleteMessageAction: F<void>;
};

export class ImageAnnotationMenu extends React.Component<ImageAnnotationMenuProps, ImageAnnotationMenuState> {
    state: ImageAnnotationMenuState = {
        showDeleteConfirmation: false,
    };

    cancelDeleteMessage = () => {
        this.setState({
            showDeleteConfirmation: false,
        });
    };

    showDeleteMessage = () => {
        this.setState({
            showDeleteConfirmation: true,
        });
    };

    render() {
        const { showDeleteConfirmation } = this.state;
        const { annotation, applyDeleteMessageAction, startEditAction } = this.props;
        const { message } = annotation;

        return (
            <Menu className={styles.menu}>
                {message.canEdit && (
                    <MenuItem
                        onClick={startEditAction}
                        className={styles.menu_item}
                        icon={icon.edit}
                        text={imageAnnotationsResx.edit}
                    />
                )}
                {message.canDelete &&
                    (showDeleteConfirmation ? (
                        <MenuItem className={styles.menu_item} icon={icon.delete} onClick={noop}>
                            <FocusTrap autoFocus={true}>
                                <ActionConfirmation
                                    title={imageAnnotationsResx.delete_comment}
                                    apply={{
                                        text: imageAnnotationsResx.apply,
                                        action: applyDeleteMessageAction,
                                    }}
                                    cancel={{
                                        text: imageAnnotationsResx.cancel,
                                        action: this.cancelDeleteMessage,
                                    }}
                                />
                            </FocusTrap>
                        </MenuItem>
                    ) : (
                        <MenuItem
                            onClick={this.showDeleteMessage}
                            className={styles.menu_item}
                            icon={icon.delete}
                            text={imageAnnotationsResx.delete}
                        />
                    ))}
            </Menu>
        );
    }
}
